module.exports = __webpack_public_path__ + "img/93.8844886.png";